import DatasetBuilder from '../../components/onboarding/DatasetBuilder';

export default function DatasetBuilderPage() {
  return <DatasetBuilder />;
}
